import { CodeType } from '../api-client/api-types'

export const trackingId = 'UA-126212690-3'
export const siteContainerWidth = 1200
export const deleteWord = 'GOODBYE'
export const dateFormatShort = 'Do MMM YY'
export const dateFormatShortMonth = 'MMM YY'
export const dateFormatShortWeek = '[wk.] ww YYYY'
export const defaultAnomalyDateRange = 90
export const defaultAnomalyDateRangeLabel = 'Last 90days'
export const defaultCampaignTableRange = 30
export const defaultCampaignTableRangeLabel = 'Last 30days'
export const maxRowsExplainTable = 3
export const sharingPermissionTypes = {
  private: {
    short: 'Private',
    long: 'Only Uplifter users can view (private)',
  },
  public: {
    short: 'Public',
    long: 'Anyone with the link below can view (public)',
  },
}

export const matchTypesDropDown = [
  {
    name: 'Campaign links',
    shortName: 'links',
    value: 'full',
    tooltip:
      'Compares metrics of landing pages with campaign codes. The best way to compare performance if **users correctly enter landing page URLs** when creating campaign links.',
  },
  {
    name: 'Campaign codes',
    shortName: 'codes',
    value: 'partial',
    tooltip:
      "Compares metrics of campaign codes, ignoring the landing page URLs. The best way to compare performance if your **users don't enter landing page URLs** when creating campaign links.",
  },
  {
    name: 'Landing pages',
    shortName: 'pages',
    value: 'lpag',
    tooltip: 'Compares metrics of landing pages. ',
  },
  // {
  //   name: 'Campaigns',
  //   shortName: 'campaigns',
  //   value: 'campaign',
  //   tooltip:
  //     'Compares aggregated campaign metrics against each other. If you want granular details within campaigns, choose campaign links and apply a campaign filter.',
  // },
  // {
  //   name: 'Sources',
  //   shortName: 'Sources',
  //   value: 'sources',
  // },
  // {
  //   name: 'Mediums',
  //   shortName: 'Mediums',
  //   value: 'medium',
  // },
  // {
  //   name: 'Terms',
  //   shortName: 'Terms',
  //   value: 'term',
  // },
  // {
  //   name: 'Ad contents',
  //   shortName: 'Ad contents',
  //   value: 'adContent',
  // },
]

export const availableToShareOptions = {
  company: {
    value: 'company',
    long: 'Company',
    desc: 'Everyone at the company can see this report.',
  },
  account: {
    value: 'account',
    long: 'Account',
    desc: 'Only people who have access to this account can see this report.',
  },
  user: {
    value: 'user',
    long: 'Private',
    desc: 'Only you can see this report.',
  },
}

export const calendarBookingLink =
  'https://outlook.office365.com/owa/calendar/Uplifteronboarding@mezzolabs.com/bookings/'

export const accountTypes = {
  '': { short: '', long: '' },
  GA_VIEW: { short: 'Google', long: 'Google Analytics' },
  AA_REPORT: { short: 'Adobe', long: 'Adobe Analytics' },
}

export const messages = {
  defaultReportTitle: 'Performance link report',
  notSet:
    'This row contains all campaign traffic where the campaign parameter was blank.',
  notValidEmail: 'Sorry, but this does not seem to be a valid email.',
  sorry: 'Sorry, we are having a few issues right now. Please try again later.',
  fileUploadError: 'We are having trouble uploading your file.',
  fileDeleteError: 'We are having trouble deleting your file.',
  fileUploadErrorImageOnly:
    'You can only upload png, gif or jpeg. Maximum file size up to 1MB.',
  alreadyHaveAccount:
    "It looks like you've already got an account associated with this email. Log in instead or reset your password if you've forgotten it",
  partialMatch:
    'We can only find aggregated data for this campaign code, not specifically the landing page URL with campaign code.',
  linkStatus: {
    'N/A': 'Please connect your analytics or email support@uplifter.ai',
    Error: 'Please connect your analytics or email support@uplifter.ai',
    Ended: 'Had data but has not received any in the last 30 days.',
    Live: 'Has had data within the last 30 days.',
    New: 'Was created in the last 30 days but does not yet have data.',
    Unused: 'Was created more than 30 days ago and has no data.',
  },
  betaTooltip:
    'This feature is new and may contain a few bugs. If you spot any, please email support@uplifter.ai or use our feedback button.',
  validateUrlMessage: {
    goodUrl:
      'This landing page is live, has a Google or Adobe analytics tag and loads in under 4 seconds. [Info](https://support.uplifter.ai/hc/en-us/articles/360020525658-What-does-landing-page-validation-do-)',
    noData:
      'An analytics tag did not fire when we visited the page, this could be due to cookie concent. [Fix](https://support.uplifter.ai/hc/en-us/articles/360020525658-What-does-landing-page-validation-do-)',
    unknownUrl: "We couldn't scan and validate your URL, contact support. Fix",
    validating: 'This is a new URL which will be validated over night.',
    badUrl:
      'This landing page URL is not currently live and users will go to an error page. [Fix](https://support.uplifter.ai/hc/en-us/articles/360020525658-What-does-landing-page-validation-do-)',
    slowLandingPage:
      'This page takes over 4 seconds to load, which is above the recommended speed time. [Fix](https://support.uplifter.ai/hc/en-us/articles/360020525658-What-does-landing-page-validation-do-)',
    noAnalyticsTag:
      'This landing page does not have a Google / Adobe analytics tag on it.',
    redirectedLandingPage:
      'This landing page redirects to another page, which can strip out campaign tracking and make the page load slow. [Fix](https://support.uplifter.ai/hc/en-us/articles/360020525658-What-does-landing-page-validation-do-)',
  },
  urlStatus: {
    slowLandingPage: `This page is slow (loads in over 4 seconds). [Fix](https://support.uplifter.ai/hc/en-us/articles/360020525658-What-does-landing-page-validation-do-)`,
    redirectedLandingPage: `This page redirects to another page. [Fix](https://support.uplifter.ai/hc/en-us/articles/360020525658-What-does-landing-page-validation-do-)`,
    invalid: `This page may not have analytics. [Fix](https://support.uplifter.ai/hc/en-us/articles/360020525658-What-does-landing-page-validation-do-)`,
    badUrl:
      'This page is not live. [Fix](https://support.uplifter.ai/hc/en-us/articles/360020525658-What-does-landing-page-validation-do-)',
  },
  customiseShortLink: 'You can change short link **alias** if available.',
  linkTypes: `**Short link (Recommended):** Create a short link that redirects to the landing page with a campaign code, *capturing* valuable clickthrough data.

**Full link:** Create a landing page with campaign code, does not go through a short link, Uplifter *will not capture* valuable clickthrough data.
`,
}
export const fieldTypes = {
  '': { short: 'Unknown', long: 'Unknown' },
  input: { short: 'Input', long: 'Free text' },
  select: { short: 'Dropdown', long: 'Dropdown' },
  date: { short: 'Date', long: 'Date picker' },
}

interface CodeStatus {
  na: CodeType
  ended: CodeType
  live: CodeType
  new: CodeType
  unused: CodeType
  error: CodeType
}

export const codeStatus: CodeStatus = {
  new: 'New',
  live: 'Live',
  ended: 'Ended',
  unused: 'Unused',
  na: 'N/A',
  error: 'Error',
}

export const detectionMethods = {
  '': { short: 'Unknown', long: 'Unknown', desc: '' },
  AE: {
    short: 'AI',
    long: 'AI anomaly detection',
    desc: 'Best for high volume metrics like Users and Revenue',
  },
  MANUAL: {
    short: 'None',
    long: 'No anomaly detection',
    desc: 'Best for low volume, highly volatile metrics like Leads',
  },
  SD: {
    short: 'SD',
    long: 'Standard deviation',
    desc:
      'Best for secondary metrics which are highly unpredictable like Bounce rate',
  },
}

export const metricSettingUp = `
This metric is still being setup, please return in an hour to breakdown anomalies and find insights. 
 
If you keep seeing this message, please email [support@uplifter.ai](mailto:support@uplifter.ai).
`

export const markdownHelp = `
Uplifter uses Markdown for formatting. Here are the basics.

First Level Header
\`\`\`
Making pancakes
===============
\`\`\`

Second Level Header
\`\`\`
Method
------
\`\`\`

Paragraphs
\`\`\`
Add two new lines to start a new paragraph. Put flour, eggs, milk, oil and a pinch of salt into a bowl.
\`\`\`


Bold
\`\`\`
**Whisk** to a smooth batter.
\`\`\`

Emphasis
\`\`\`
Set a medium frying pan over a *medium heat*.
\`\`\`

Lists
\`\`\`
Ingredients:  
- flour
- eggs
- *optional:* milk or oat milk
- oil
\`\`\`

`

export default {
  siteContainerWidth,
}

export const performanceDates: PerformanceDate[] = [
  {
    displayName: 'Custom date range',
    metricValue: 'custom',
    label: 'custom',
    granularity: 'daily',
  },
  {
    displayName: 'This month',
    metricValue: 'thisMonth',
    label: 'this month',
    granularity: 'daily',
    disableGranularity: 'monthly',
  },
  {
    displayName: 'Last month',
    metricValue: 'lastMonth',
    label: 'last month',
    granularity: 'daily',
    disableGranularity: 'monthly',
  },
  {
    displayName: 'This quarter',
    metricValue: 'thisQuarter',
    label: 'this quarter',
    granularity: 'weekly',
  },
  {
    displayName: 'Last quarter',
    metricValue: 'lastQuarter',
    label: 'last quarter',
    granularity: 'weekly',
  },
  {
    displayName: 'This year',
    metricValue: 'thisYear',
    label: 'last 13 months',
    granularity: 'monthly',
  },
]

export const granularityFilterData: GranularityData[] = [
  { name: 'Month', value: 'monthly' },
  { name: 'Quarter', value: 'quarterly' },
  { name: 'Week', value: 'weekly' },
  { name: 'Day', value: 'daily' },
]

export const presetColors = [
  '#FFFFFF',
  '#000000',
  '#A0AEC0',
  '#E61969',
  '#0FC3F0',
  '#007D9B',
  '#FFD70F',
]

export const graphColours = [
  '#007d9b',
  '#e61969',
  '#0fc3f0',
  '#ffd70f',
  '#718096',
  '#4285f4', // Google colours
  '#34a853',
  '#fbbc05',
  '#ea4335',
  '#EB4787', // light colours
  '#3FCFF3',
  '#3397AF',
  '#FFDF3F',
]

export const graphColoursMedium = ['#EB4787', '#3FCFF3', '#3397AF', '#FFDF3F']

export const graphColoursMuted = ['#F075a5', '#6fdbf6', '#66b1c3', '#ffe76f']

export const integrationData = {
  aa: {
    full: 'Adobe Analytics',
    icon: '/aa-logo.svg',
  },
  sf: {
    full: 'Salesforce',
    icon: '/salesforce-logo.svg',
  },
  fb: {
    full: 'Facebook',
    icon: '/fb-logo.svg',
  },
  t: {
    full: 'Twitter',
    icon: '/twitter-logo.svg',
  },
  li: {
    full: 'LinkedIn',
    icon: '/linkedin-logo.svg',
  },
  ftc: {
    full: 'Google Marketing Platform',
    icon: '/gmp-logo.svg',
  },
}

export const defaultHomepageSlugs = {
  welcome: '/welcome',
  audit: '/audit',
  explain: '/explain',
  report: '/report/performance',
  track: '/track/create-campaign-codes',
}
